import * as api from '@gitbook/api-client';
import type {
    OrganizationBilling,
    OrganizationBillingWithUpdatableSubscription,
} from '@gitbook/app-database';

// Stripe does not allow updating subscriptions in these statuses
export const NON_UPDATABLE_STATUSES = ['canceled', 'incomplete_expired', 'trialing', 'paused'];

/**
 * A list of the legacy products that are allowed to self-serve migrate to new pricing
 */
export const NEW_PRICING_ELIGIBLE_LEGACY_PRODUCTS = [
    api.BillingProduct.Free,
    api.BillingProduct.Plus,
    api.BillingProduct.Pro,
];

/**
 * All the migration discounts we defined in Stripe and for which plans they are available for.
 */
export const MIGRATION_DISCOUNTS: Partial<
    Record<api.BillingProduct, Record<api.BillingInterval, api.BillingDiscount>>
> = {
    [api.BillingProduct.Plus]: {
        [api.BillingInterval.Monthly]: {
            duration: 6,
            percentOff: 15,
        },
        [api.BillingInterval.Yearly]: {
            duration: 12,
            percentOff: 15,
        },
    },
    [api.BillingProduct.Pro]: {
        [api.BillingInterval.Monthly]: {
            duration: 6,
            percentOff: 15,
        },
        [api.BillingInterval.Yearly]: {
            duration: 12,
            percentOff: 15,
        },
    },
};

/**
 * Checks whether the given plan can migrate to new pricing
 */
export function canPlanMigrateToNewPricing(plan: api.Organization['plan']) {
    return NEW_PRICING_ELIGIBLE_LEGACY_PRODUCTS.includes(plan);
}

/**
 * Asserts whether the given plan can migrate to new pricing:
 */
export function assertOrganizationPlanCanMigrateToNewPricing(
    organizationId: string,
    billing: OrganizationBilling
): asserts billing is OrganizationBillingWithUpdatableSubscription {
    if (!canPlanMigrateToNewPricing(billing.product)) {
        throw new Error(
            `Organization (${organizationId}) billing is on an unsupported legacy product (${billing.product}).`
        );
    }
}
